import { isCard } from "@circle-react/helpers/paywallCheckoutHelpers";

export const useCardInfo = (
  paywall: any,
  selectedPrice: any,
  payment_method_type: any,
  isCardInfoComplete: boolean,
  isMemberWithSavedPaymentMethods: boolean,
  isMemberUsingSavedPaymentMethod: boolean,
  isFreeForever: boolean,
) => {
  const isCardInfoRequired =
    (!selectedPrice.trial_enabled ||
      selectedPrice.trial_requires_upfront_payment ||
      paywall.trial_requires_card) &&
    isCard(payment_method_type) &&
    !isFreeForever;
  const isCardInfoValid = !isCardInfoRequired || isCardInfoComplete;

  const isFreeTrialThatRequiresCard =
    selectedPrice.trial_enabled &&
    isCard(payment_method_type) &&
    paywall.trial_requires_card &&
    !selectedPrice.trial_requires_upfront_payment;

  const isSetupIntentRequired =
    (!isMemberWithSavedPaymentMethods && isFreeTrialThatRequiresCard) ||
    (isMemberWithSavedPaymentMethods && !isMemberUsingSavedPaymentMethod);

  return {
    isCardInfoRequired,
    isCardInfoValid,
    isSetupIntentRequired,
  };
};
